import {Tooltip} from 'platform/components';
import {HStack, Icon, Text, ThemeColorTextPath} from 'platform/foundation';
import {match, Pattern} from 'ts-pattern';

import {always} from 'ramda';

import {usePendingRequests} from '../../../hooks/usePendingRequests';
import {getFixedTranslation} from '../../../utils/getFixedTranslation';

export function PendingRequests() {
  const pendingCount = usePendingRequests();

  const countColor = match<number, ThemeColorTextPath>(pendingCount)
    .with(Pattern.number.gte(10), always('danger'))
    .with(Pattern.number.gte(5), always('warning'))
    .with(0, always('tertiary'))
    .otherwise(always('success'));

  return (
    <Tooltip label={getFixedTranslation('page.settings.labels.pendingRequests')}>
      <HStack spacing={1} align="center">
        <Icon value="navigation/arrow_upward" color="text.tertiary" size={4} />
        <Text color={countColor}>{pendingCount}</Text>
      </HStack>
    </Tooltip>
  );
}
